const styles = {
  message: {
    margin: '10% auto',
  },
}

export default styles
